/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_DescriptionInputs */

const et_plan_visibility_description = /** @type {(inputs: Plan_Visibility_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kui sul on veebileht juba olemas ja soovid rohkem nähtavust Google's ning AI-otsingutes.`)
};

const en_plan_visibility_description = /** @type {(inputs: Plan_Visibility_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you already have a website and want more visibility on Google and in AI search.`)
};

/**
* | output |
* | --- |
* | "If you already have a website and want more visibility on Google and in AI search." |
*
* @param {Plan_Visibility_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_description = /** @type {((inputs?: Plan_Visibility_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_description(inputs)
	return en_plan_visibility_description(inputs)
});